// data/faqData.js

export const faqData = {
  hospital: [
    {
      question: "What is a Hospital Management Software and why do we need it in 2026?",
      answer:
        "The hospital management software assists hospitals in handling clinical, administrative and financial functions within one platform. It is needed in 2026 to be efficient, compliant, and scalable in delivering healthcare in India."
    },
    {
      question: "What does a Hospital Information System in India mean as compared to basic hospital software?",
      answer:
        "Indian Hospital Information System combines various departments such as OPD, IPD, billing, diagnostics, and pharmacy in a single system. Simple software usually does not have interoperability and live data flow."
    },
    {
      question: " What should hospitals look for in a Hospital Management software company in India?",
      answer:
        "Domain experience, scalability, compliance readiness and post-implementation support should be evaluated by the hospitals. A reliable Hospital Management software company in India focuses on long-term partnership, not just deployment."
    },
    {
      question: "Does HIMS software in India apply to small clinics and large hospitals?",
      answer:
        "Indeed, HIMS software in contemporary India is designed to scale across clinics, mid-sized hospitals, and multi-location healthcare organizations. The trick here is to select a system that has a modular and configurable architecture."
    },
    {
      question: "Which is considered the best Hospital Management Software in India today",
      answer:
        "The best Hospital Management Software in India is one that aligns with real hospital workflows, ensures data security, and supports growth. It is not a one-size-fits-all solution; it depends on hospitals' needs."

    },
    {
      question: "What does Hospital Management Software do to enhance patient experience?",
      answer:
        "Hospital Management Software improves the patient experience by enhancing registration, accurate billing, electronic reporting, and interdepartmental coordination. This minimises the wait time and enhances patient transparency."
    },

  ],

  billing: [
    {
      question: "Can HMS manage payments?",
      answer:
        "Yes, HMS software includes billing, payment tracking, and invoice management."
    },
    {
      question: "Can HMS send reminders?",
      answer:
        "Yes, appointment and payment reminders can be automated."
    }
  ],

  emr: [
    {
      question: "What is EMR in HMS?",
      answer:
        "EMR stores patient medical records digitally and makes them accessible anytime."
    }
  ]
};
export default faqData;